import AdvertsGridComponent from 'components/Grids/AdvertsGrid';
import UserPicker from 'components/Pickers/UserPicker';
import OnlyTitleSummaryBar from 'components/SummaryBars/OnlyTitleSummaryBar';
import PageContentLayout from 'layouts/PageContentLayout';
import PageLayout from 'layouts/PageLayout';
import React, { useEffect, useMemo, useState } from 'react';
import { getJwtPayload } from 'util/AuthUtils';

const summaryBar = (
  <OnlyTitleSummaryBar
    title="Adverts > Live > Consultant"
    browserTabTitle="Consultant > Live > Adverts"
  />
);

export default function ConsultantLiveAdvertsPage() {
  const [userSource, setUserSource] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const jwtPayload = getJwtPayload();
    if (jwtPayload) setUserSource(jwtPayload.UserID);
  }, []);

  const extraActions = useMemo(() => {
    return (
      <UserPicker
        label="Consultant"
        userId={userSource}
        onSelect={(u) => setUserSource(u ? u.id : 0)}
        sx={{ flex: '1 1 0' }}
      />
    );
  }, [userSource]);

  return (
    <>
      <PageLayout SummaryBar={summaryBar}>
        <PageContentLayout showLoading={isLoading}>
          <AdvertsGridComponent
            source="consultant-live-adverts"
            sourceId={userSource}
            gridName="adverts/live/consultant"
            loadingHandler={setIsLoading}
            extraActions={extraActions}
          />
        </PageContentLayout>
      </PageLayout>
    </>
  );
}
